import { useEffectOnce } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';

import { makeFetchEntityByIdSelector } from '../selectors/fetch';
import { registerFetchEntity, fetch } from '../actions/fetch';

const useFetch = (id, url, options, mapper) => {
  const dispatch = useDispatch();
  const fetchEntity = useSelector(makeFetchEntityByIdSelector(id));

  const onFetch = (options = {}) => dispatch(fetch(id, url, options, mapper));
  const onSubmit = ({ body, method, ...rest }) =>
    dispatch(
      fetch(id, url, {
        method: method || 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        ...rest,
      })
    );

  useEffectOnce(() => {
    if (!fetchEntity.isInit) dispatch(registerFetchEntity(id, options));
  });

  return {
    ...fetchEntity,
    onFetch,
    onSubmit,
  };
};

export default useFetch;
